import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  OligoName: {
    fontSize: theme.typography.pxToRem(14),
    wordBreak: 'break-word',
    cursor: 'pointer',
  },
  seqWordWrap: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
  },
  seqWordWrapwithDot: {
    width: '100%',
    fontSize: theme.typography.pxToRem(14),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    wordBreak: 'break-all',
    fontWeight: theme.typography.fontWeightLight,
  },
  shiftRight: {
    marginRight: theme.spacing(-15),
    fontSize: theme.typography.pxToRem(14),
  },
  sequenceSpacing: {
    marginTop: theme.spacing(1),
  },
  priceText: {
    fontSize: theme.typography.pxToRem(14),
    marginRight: theme.typography.pxToRem(-25),
    textAlign: 'right',
  },
  invalidSpecificationText: {
    padding: theme.spacing(0, 0, 0, 0),
    marginRight: theme.spacing(-10),
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(-2),
  },
  specsError: {
    borderLeft: `${theme.spacing(2)}px solid #f70303`,
    fontSize: theme.typography.pxToRem(13),
  },
  message: {
    padding: theme.spacing(2.5, 2.5, 2.5, 2.5),
  },
  oligoCount: {
    fontSize: theme.typography.pxToRem(16),
  },
  duplexCount: {
    fontSize: theme.typography.pxToRem(16),
    marginLeft: theme.spacing(4),
  },
  InfoPopup: {
    maxWidth: theme.spacing(55),
    backgroundColor: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(12),
    color: '#151515',
    boxShadow: theme.shadows[5],
    display: 'table',
    wordBreak: 'break-all',
    marginTop: theme.spacing(0.5),
  },
  switchRoot: {
    height: 44,
    width: 52,
    paddingLeft: 5,
  },
  width43: {
    width: theme.spacing(43),
  },
  switchTrack: {
    borderRadius: 10,
    backgroundColor: '#a1a1a1',
  },
  switchBase: {
    top: 8,
    left: 2,
    padding: 5,
    '&$checked': {
      color: '#fff',
      transform: 'translateX(14px)',
      '& + $switchTrack': {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.9,
      },
    },
  },
  thumb: {
    width: 17,
    height: 17,
    color: theme.palette.common.white,
  },
  switchInput: {
    width: '238%',
  },
  checked: {},
  WellSectionText: {
    padding: theme.spacing(4, 4, 4, 4),
    borderLeft: `${theme.spacing(1)}px solid #F7A703`,
    border: `${theme.spacing(0.2)}px solid #F7A703`,
    borderRadius: theme.shape.borderRadius,
    fontSize: theme.typography.pxToRem(13),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    position: 'relative',
    display: 'inline-block',
  },

  messageText: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  warningIcon: {
    color: '#F7A703',
    marginBottom: theme.spacing(-0.8),
  },
  noteInfo: {
    padding: theme.spacing(3),
    border: `solid 1px ${theme.palette.primary.main}`,
    borderRadius: theme.typography.pxToRem(5),
    width: '100%',
    borderLeftWidth: 'thick',
    marginTop: theme.spacing(3),
  },
  InfoIcon: {
    position: 'relative',
    fontSize: theme.typography.pxToRem(16),
    top: theme.spacing(0.5),
    marginLeft: theme.spacing(1.5),
  },
  InfoText: {
    marginRight: theme.spacing(-8),
  },
  marginLeft4: {
    marginLeft: theme.spacing(4),
  },
  overflow: {
    overflow: 'hidden',
  },
  textLeft: {
    float: 'left',
    marginTop: theme.spacing(-0.75),
  },
  textInputOthers: {
    width: theme.spacing(30),
    height: theme.spacing(8),
    marginLeft: theme.spacing(-7),
  },
  registeredSymbol: {
    verticalAlign: 'super',
    fontSize: theme.typography.pxToRem(15),
  },
  warningMsg: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.common.black,
    paddingTop: theme.spacing(0.5),
  },
  warningBorder: {
    border: `${theme.spacing(0.5)}px solid #F7A703 `,
    padding: theme.spacing(4),
    borderRadius: theme.typography.pxToRem(5),
    borderLeftWidth: 'thick',
  },
  validationWarningsTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(12),
    verticalAlign: 'top',
    color: '#F7A703',
    paddingRight: theme.spacing(3),
  },
  validationWarningsMessage: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(12),
    maxWidth: theme.spacing(212),
    position: 'relative',
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
  validationWarningBorder: {
    border: `${theme.spacing(0.3)}px solid #F7A703`,
    padding: theme.spacing(3, 3),
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    borderLeftWidth: 'thick',
    display: 'inline-block',
  },
  tableBorder: {
    display: 'block',
  },
  paddingLeft9: {
    paddingLeft: theme.spacing(9),
  },
  warningBox: {
    padding: theme.spacing(3, 0, 0, 0),
  },
  verticalAlignTop: {
    verticalAlign: 'top',
  },
  plateWarningBox: {
    padding: theme.spacing(1, 0, 0, 12),
  },
  milliplexRegisteredSymbol: {
    verticalAlign: 'text-top',
    fontSize: theme.typography.pxToRem(16),
  },
  globalHelpTextColor: {
    color: theme.palette.common.black,
  },
  globalBlackFontColor: {
    color: theme.palette.common.black,
  },
  deleteAllMargin: {
    marginRight: theme.spacing(-3.75),
    marginLeft: theme.spacing(-1),
  },
  deleteAllPadding: {
    padding: theme.spacing(5.5),
  },
  sequenceBaseCountText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  placeHolderColorChanges: {
    '& ::-webkit-input-placeholder': {
      color: theme.palette.common.black,
      opacity: '1',
    },
    '& :-ms-input-placeholder': {
      color: theme.palette.common.black,
      opacity: '1',
    },
    '& ::-ms-input-placeholder': {
      color: theme.palette.common.black,
      opacity: '1',
    },
    '& :-moz-placeholder': {
      color: theme.palette.common.black,
      opacity: '1',
    },
    '& ::-moz-placeholder': {
      color: theme.palette.common.black,
      opacity: '1',
    },
    '& ::placeholder': {
      color: theme.palette.common.black,
      opacity: '1',
    },
  },
  reviewtableScrollbarpadding: {
    marginLeft: theme.spacing(-7.75),
  },
  reviewtabledeletepadding: {
    marginLeft: theme.spacing(-4),
  },
  dFlexForZHLang: {
    display: 'flex',
    paddingRight: theme.spacing(4),
  },
  dFlex: {
    display: 'flex',
  },
  deleteAllTextCss: {
    fontSize: theme.typography.pxToRem(16),
  },
  deleteMarginCss: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5.5),
  },
  deleteButtonCss: {
    padding: theme.spacing(0),
  },
  subHeadCss: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
  },
  headerCss: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(3, 0),
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  baseButton: {
    border: 0,
    background: 'none',
    cursor: 'pointer',
    height: theme.spacing(8),
    minWidth: theme.spacing(8),
    fontSize: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(2),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    transition: 'all .2s ease-in-out',
    '&:disabled': {
      cursor: 'auto',
      color: theme.palette.text.disabled,
    },
    '&:hover:enabled': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
  },
  marginButton: {
    fontSize: theme.typography.pxToRem(24),
  },
  marginButtonRight: {
    fontSize: theme.typography.pxToRem(24),
  },
  prevNext: {
    color: theme.palette.primary.main,
  },
  pageNumber: {
    color: theme.palette.common.black,
  },
  curPage: {
    cursor: 'auto',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  ellipsis: {
    cursor: 'auto',
  },
  fontWeightForServices: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'normal',
    width: 'fit-content',
    display: 'inline-table',
  },
  specificationsWrapperServices: {
    '& span.MuiFormControlLabel-label': {
      fontSize: theme.typography.pxToRem(14),
    },
    marginTop: theme.spacing(5),
  },
  boldCss: {
    fontWeight: theme.typography.fontWeightBold,
    paddingLeft: theme.spacing(157),
  },
  breakword: {
    overflowWrap: 'break-word',
  },
  leftElement: {
    marginLeft: theme.spacing(-2),
  },
  subscript: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    bottom: theme.spacing(-2),
    left: theme.spacing(-1),
    position: 'relative',
  },
  subToSubscriot: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    bottom: theme.spacing(-2),
    position: 'relative',
  },
  checkedIcon: {
    '& .MuiIconButton-root.Mui-disabled': {
      color: theme.palette.grey[400],
    },
  },
  titleText: {
    fontSize: theme.typography.pxToRem(20),
    textTransform: 'uppercase',
    fontWeight: 900,
  },
  deleteButton: {
    cursor: 'pointer',
  },
  titleContainer: {
    marginBottom: theme.spacing(4),
  },
  deleteContainer: {
    marginBottom: theme.spacing(2),
  },
  addItemButton: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 900,
    color: theme.palette.primary.main,
  },
  addItemButtonContainer: {
    marginTop: theme.spacing(4),
  },
  clearIcon: {
    color: theme.palette.common.black,
  },
  primaryColor: {
    color: theme.palette.primary.main,
  },
  nameLink: {
    fontWeight: 900,
    color: theme.palette.primary.main,
  },
}))
export default useStyles
